import {
    createContext,
    useContext,
    useEffect,
    useReducer,
    useMemo,
} from 'react';
import { HeaderContext } from '@contexts/HeaderContext';
import { LoginDataAction, LoginDataReducer, getInitialLoginDataState } from '@reducers/LoginDataReducer';

export const LoginDataContext = createContext(null);

export const useLoginContext = () => {
    return useContext(LoginDataContext);
};

export const LoginDataProvider = ({ children }) => {
    const [headerState] = useContext(HeaderContext);
    const loginData = getInitialLoginDataState({
        platform: headerState.platform,
        language: headerState.language,
        enterPoint: headerState.enterPoint,
    });

    const [loginDataState, loginDataDispatch] = useReducer(
        LoginDataReducer,
        loginData,
    );

    useEffect(() => {
        loginDataDispatch({
            type: LoginDataAction.UPDATE_LOGIN_DATA_HEADER_STATE,
            payload: {
                platform: headerState.platform,
                language: headerState.language,
                enterPoint: headerState.enterPoint,
            },
        });
    }, [loginDataDispatch,
        headerState.enterPoint,
        headerState.language,
        headerState.platform]);

    const valueContext = useMemo(() => [loginDataState, loginDataDispatch], [loginDataState, loginDataDispatch]);

    return (
        <LoginDataContext.Provider value={valueContext}>
            {children}
        </LoginDataContext.Provider>
    );
};
